export default __webpack_public_path__ + "static/media/electricLight.png";